import moment from "moment";
import { authInstance } from "./axios";

let url = process.env.REACT_APP_API_URL;

function formatDate(v) {
  if (v == null || v === "") return null;
  const d = moment(v);
  return d.isValid() ? d.format("YYYY-MM-DD") : v;
}

export const servScalePriceService = {
  getLast: async () => {
    const response = await authInstance
      .get(`${url}/parameters/servScalePrice/last`)
      .then(async (r) => r)
      .catch(function (error) {
        error.data = null;
        return error;
      });
    return response;
  },
  save: async (data) => {
    const response = await authInstance
      .post(`${url}/parameters/servScalePrice`, data)
      .then(async (r) => r)
      .catch(function (error) {
        error.data = null;
        return error;
      });
    return response;
  },
  /**
   * @param {{ dateSinceInit: Date, dateSinceEnd: Date, fields?: string[], limit: number, page: number }} query
   */
  getHistory: async ({ dateSinceInit, dateSinceEnd, fields, limit, page }) => {
    const params = {
      dateSinceInit: formatDate(dateSinceInit),
      dateSinceEnd: formatDate(dateSinceEnd),
      limit,
      page,
    };
    if (fields?.length) {
      params.fields = fields;
    }
    const response = await authInstance
      .get(`${url}/parameters/servScalePrice/history`, { params })
      .then(async (r) => r)
      .catch(function (error) {
        error.data = null;
        return error;
      });
    return response;
  },
};
